<template>
	<header class="header">
		<b-container fluid>
			<b-row>
				<b-col class="logo">
					<a :href="$t('homeURL')" target="_blank">
						<img :src="logo" class="logo__img" alt="Bolagsverket" />
					</a>
				</b-col>
				<div v-show="env !== null" class="environment">Miljö: {{ env }}</div>
			</b-row>
		</b-container>
	</header>
</template>

<script>
export default {
	data: function() {
		return {
			env: null,
		};
	},
	computed: {
		logo: function() {
			return require("@/assets/images/logos/" + this.$t("bvLogo"));
		},
	},
	created: function() {
		const hostname = window.location.hostname;
		if (hostname === "developer.bolagsverket.se") {
			this.env = "utv";
		} else {
			let envPattern = /.*-(.*)\.bolagsverket\.se/;
			let match = hostname.match(envPattern);
			this.env = match ? match[1] : null;
		}
	},
};
</script>

<style scoped>
.header {
	background: #ffffff;
	position: relative;
	z-index: 1;
	padding: 0.8em 0;
}
.logo__img {
	height: 2rem;
}


.environment {
	color: black;
	font-size: 14px;
	position: fixed;
	top: 0;
	left: 0;
	padding-left: 2em;
	padding-right: 2em;
	text-align: left;
	background: rgba(255, 100, 135, 0.2);
}

</style>
